import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useScrollOverflow } from '#pplx/frontend/aether/internal/useScrollOverflow.js';
import classNames from 'classnames';
import { useRef } from 'react';
const GRADIENT_BASE = 'pointer-events-none absolute inset-x-0 z-10 h-6 from-base to-transparent transition-opacity duration-150';
export function ModalScrollableBody({ children, className, }) {
    const scrollRef = useRef(null);
    const { canScrollUp, canScrollDown } = useScrollOverflow(scrollRef);
    return (_jsxs("div", { className: "relative flex min-h-0 flex-1 flex-col", children: [_jsx("div", { className: classNames(GRADIENT_BASE, 
                // offset for the negative margin
                '-top-1 bg-linear-to-b', canScrollUp ? 'opacity-100' : 'opacity-0') }), _jsx("div", { ref: scrollRef, className: classNames(
                // The 2px focus outline plus 2px offset need a 4px gutter; the matching
                // negative margin preserves alignment with the other modal sections.
                'min-h-0 flex-1 overflow-y-auto p-1 -m-1', className), children: children }), _jsx("div", { className: classNames(GRADIENT_BASE, 
                // offset for the negative margin
                '-bottom-1 bg-linear-to-t', canScrollDown ? 'opacity-100' : 'opacity-0') })] }));
}
//# sourceMappingURL=ModalScrollableBody.js.map